import { render } from "./QuestionNavigationMenu.vue?vue&type=template&id=08d4983d&scoped=true"
import script from "./QuestionNavigationMenu.vue?vue&type=script&lang=js"
export * from "./QuestionNavigationMenu.vue?vue&type=script&lang=js"

import "./QuestionNavigationMenu.vue?vue&type=style&index=0&id=08d4983d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d4983d"]])

export default __exports__